import FloatingButton from './FloatingButton.component';

export default FloatingButton;